// The published room-name overlay (/api/room-names), applied to the rows read
// from the authored RoomNames/<slug>.csv sheets.
//
// ## ⚠️ ONE IMPLEMENTATION, meant to be mirrored — not rewritten
//
// This is the only code that decides what a room is called once the operator
// has published a name for it. The website runs it in PathfinderPage and the
// Event Creator as the sheets load; the phone app copies THIS FILE byte-for-
// byte into `src/places/lib/` (beside `placeEdits.js`, for the same reason)
// rather than re-deriving the rule, because two merges that disagree mean a
// room is "SSA Lounge" on one client and "Armes 209" on the other. Pure — no
// browser API, no import. Pinned by `node src/utils/roomNameOverlay.test.mjs`.
//
// ## The rule, all of it
//
//  · `rows` are the sheet rows the pathfinder's `loadRoomNames` produced:
//    `[{ building, roomNumber, roomName }]`, blank names already dropped.
//  · `names` is the overlay: `{ "<slug>::<room lower-cased>": { building,
//    roomNumber, name } }`. An entry REPLACES the sheet's row for that room.
//  · An entry whose `name` is "" removes the sheet's name and adds nothing:
//    "this room has no name" is a statement, and the room goes back to being
//    its number.
//  · No overlay, or an empty one, hands back the SAME array, so a memo keyed
//    on it does not bust; no rows and no overlay stays null.

const key = (building, roomNumber) => `${building}::${String(roomNumber).toLowerCase()}`;

/** The sheet rows with the published names laid over them. */
export function applyRoomNameOverlay(rows, names) {
  if (!names || typeof names !== 'object' || Array.isArray(names) || !Object.keys(names).length) return rows;
  const out = [];
  const taken = new Set();
  for (const [id, e] of Object.entries(names)) {
    if (!e || typeof e !== 'object' || typeof e.building !== 'string' || !e.building) continue;
    const roomNumber = String(e.roomNumber ?? '').trim();
    if (!roomNumber) continue;
    taken.add(id);
    const name = typeof e.name === 'string' ? e.name.trim() : '';
    if (name) out.push({ building: e.building, roomNumber, roomName: name });
  }
  for (const r of Array.isArray(rows) ? rows : []) {
    if (r && !taken.has(key(r.building, r.roomNumber))) out.push(r);
  }
  return out.length ? out : (Array.isArray(rows) ? out : null);
}
